import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import {
  RgV2ReviewStatusParam,
  RgV2RiskAggregationOrderBy,
  RgV2RiskLevelsParam,
} from '@/utils/query/params';

export const queryParams = {
  after: StringParam,
  before: StringParam,
  from: DateTimeParam,
  to: DateTimeParam,
  calculatedAtFrom: DateTimeParam,
  calculatedAtTo: DateTimeParam,
  desc: withDefault(BooleanParam, true),
  first: withDefault(NumberParam, 20),
  last: NumberParam,
  lastReviewedFrom: DateTimeParam,
  lastReviewedTo: DateTimeParam,
  orderBy: RgV2RiskAggregationOrderBy,
  percentageFrom: NumberParam,
  percentageTo: NumberParam,
  playerGlobalId: StringParam,
  rgCraReviewStatus: RgV2ReviewStatusParam,
  rgCraRiskLevels: RgV2RiskLevelsParam,
  rgCraRiskTermRiskId: StringParam,
  rgCraRiskTermRiskLevels: RgV2RiskLevelsParam,
};
